<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="LINESPACE" id="epi"> </p>
<p class="FMEP"><span aria-label="vii" id="pg_vii" role="doc-pagebreak">“I have come for my courage,” announced the Lion, entering the room.</span></p>
<p class="FMEPI">“Very well,” answered the little man; “I will get it for you.”</p>
<p class="FMEPI">He went to a cupboard and reaching up to a high shelf took down a square green bottle, the contents of which he poured into a green-gold dish, beautifully carved. Placing this before the Cowardly Lion, who sniffed at it as if he did not like it, the Wizard said:</p>
<p class="FMEPI">“Drink.”</p>
<p class="FMEPI">“What is it?” asked the Lion.</p>
<p class="FMEPI">“Well,” answered Oz, “if it were inside of you, it would be courage. You know, of course, that courage is always inside one; so that this really cannot be called courage until you have swallowed it. Therefore I advise you to drink it as soon as possible.”</p>
<p class="FMEPI">The Lion hesitated no longer, but drank till the dish was empty.</p>
<p class="FMEPI">“How do you feel now?” asked Oz.</p>
<p class="FMEPI">“Full of courage,” replied the Lion, who went joyfully back to his friends to tell them of his good fortune.</p>
<p class="FMEPC">—<b>L. FRANK BAUM,</b> <i>The Wonderful Wizard of Oz</i></p>
<p class="FMEPF">“This time for me! For me! For me! For me! For me! For me! For me!”</p>
<p class="FMEPC">—<b>STEPHEN SONDHEIM,</b> <i>Gypsy</i></p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?32cf047c